
export { default as IBuyMobile } from "./lib/iBuyMobile"